import {
    Component,
    Input,
    Optional,
    Inject,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from "@angular/core";
import { SupplierDataDetailsViewComponent } from "../../../../modules/group-booking/supplier-data-details/supplier-data-details.view.component";
import { IntlService } from "@progress/kendo-angular-intl";
import { CustomAuthorizationService } from "../../../../core/auth/custom-authorization.service";

@Component({
    selector: "djiv-group-booking-detail-table",
    templateUrl: "./djiv-group-booking-detail-table.component.html",
    styleUrls: ["./djiv-group-booking-detail-table.component.css"],
})
export class DJIVGroupBookingDetailTableComponent implements OnChanges {
    @Input() BookingData;
    @Input() ServiceType: string;
    @Input() IsLoading: boolean;
    @Input() isGuidedTour: boolean;
    @Output() requestApproval: EventEmitter<any> = new EventEmitter();
    @Output() requestDecline: EventEmitter<any> = new EventEmitter();
    public displayUnitReference: boolean = false;
    public hideRequestApproval: boolean = true;
    public pageSettings;
    public declineRequestOpened: boolean = false;
    public approveRequestOpened: boolean = false;
    public DeclineComment: string = "";
    public selectedBooking: any;
    public hasOnRequestBookings: boolean = false;

    constructor(
        @Optional() public parent: SupplierDataDetailsViewComponent,
        @Inject(IntlService) protected intl: IntlService,
        @Inject(CustomAuthorizationService)
        protected customAuthorizationService: CustomAuthorizationService,
    ) {
        Promise.all([
            this.customAuthorizationService.processAuthorizationResponse(),
        ]).then(() => {
            this.pageSettings =
                this.customAuthorizationService.getPageSettings(
                    "GroupBookings",
                );
            this.hideRequestApproval =
                this.pageSettings.filter(function (setting) {
                    return setting.AuthorizationMethod == "OnRequestApproval";
                })[0].AuthorizationAction == "Hide";
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["BookingData"]) {
            this.hasOnRequestBookings = (this.BookingData || []).some(
                (booking: any) =>
                    booking.BookingStatus === "OnRequest" && booking.UnitNr,
            );
        }
    }

    getFormatedDate(e) {
        let date = this.intl.formatDate(e);
        return e;
    }

    openApproveDialog(item: any) {
        this.approveRequestOpened = true;
        this.selectedBooking = item;
    }

    approveRequest() {
        this.requestApproval.emit(this.selectedBooking);
    }

    closeDialog() {
        this.approveRequestOpened = false;
        this.declineRequestOpened = false;
        this.DeclineComment = "";
    }

    declineOpen(item: any) {
        this.selectedBooking = item;
        this.declineRequestOpened = true;
        this.DeclineComment = "";
    }

    declineRequest() {
        this.selectedBooking.BookingComment = this.DeclineComment;
        this.requestDecline.emit(this.selectedBooking);
    }
}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-tables/djiv-group-booking-detail-table/djiv-group-booking-detail-table.component.ts